<div class="page-layout blank fullwidth p-12 wc-page-wrapper">
<div class="wc-container-unique-main" *ngIf="showCertificateUI">
    <div id="certificateDiv" class="wc-container-unique">
    <div class="wc-header-unique">
        <img src="../../../../assets/icons/autoverse-logo.jfif">
        <div class="wc-cert-info-unique">
        <span>Certificate No.</span>
        <strong>{{certificateNumber}}</strong>
        </div>
    </div>

    <h1 class="wc-title-unique">WARRANTY CERTIFICATE</h1>
    <div class="background-color-div">
        <p class="wc-subtitle-unique">Issued through Autoverse in partnership with your trusted garage</p>

        <div class="wc-grid-unique">
            <div class="wc-card-unique">
                 <div class="card-icon-and-class-name">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.394 2.08003C10.2695 2.02667 10.1355 1.99915 10 1.99915C9.86455 1.99915 9.73051 2.02667 9.60601 2.08003L2.60601 5.08003C2.42562 5.15688 2.2718 5.28506 2.16368 5.44864C2.05557 5.61221 1.99792 5.80396 1.99792 6.00004C1.99792 6.19611 2.05557 6.38786 2.16368 6.55143C2.2718 6.71501 2.42562 6.84319 2.60601 6.92004L5.25001 8.05103C5.34815 7.94003 5.46975 7.85224 5.60601 7.79403L9.60601 6.08004C9.72682 6.02829 9.85665 6.00086 9.98807 5.99929C10.1195 5.99772 10.2499 6.02205 10.3719 6.0709C10.494 6.11974 10.6052 6.19214 10.6992 6.28396C10.7932 6.37578 10.8683 6.48522 10.92 6.60604C10.9717 6.72685 10.9992 6.85668 11.0008 6.9881C11.0023 7.11952 10.978 7.24996 10.9291 7.37197C10.8803 7.49399 10.8079 7.60519 10.7161 7.69923C10.6243 7.79326 10.5148 7.86829 10.394 7.92004L7.66701 9.08804L9.60701 9.91903C9.73137 9.97226 9.86523 9.99971 10.0005 9.99971C10.1358 9.99971 10.2696 9.97226 10.394 9.91903L17.394 6.91903C17.5744 6.84219 17.7282 6.71401 17.8363 6.55043C17.9444 6.38686 18.0021 6.19511 18.0021 5.99904C18.0021 5.80296 17.9444 5.61121 17.8363 5.44764C17.7282 5.28406 17.5744 5.15588 17.394 5.07904L10.394 2.08003ZM3.31001 9.39704L5.00001 10.12V14.222C4.65376 14.1433 4.30314 14.0852 3.95001 14.048C3.72215 14.0241 3.50943 13.9226 3.34742 13.7606C3.18542 13.5986 3.08395 13.3859 3.06001 13.158C2.9285 11.8989 3.01305 10.6266 3.31001 9.39604V9.39704ZM9.30001 16.573C8.62402 15.9098 7.84786 15.357 7.00001 14.935V10.978L8.81801 11.758C9.1915 11.9181 9.59364 12.0007 10 12.0007C10.4064 12.0007 10.8085 11.9181 11.182 11.758L16.69 9.39704C16.9887 10.6274 17.0733 11.9 16.94 13.159C16.9161 13.3869 16.8146 13.5996 16.6526 13.7616C16.4906 13.9236 16.2779 14.0251 16.05 14.049C14.0325 14.2611 12.1465 15.1508 10.7 16.573C10.5131 16.7563 10.2618 16.8589 10 16.8589C9.73825 16.8589 9.48694 16.7563 9.30001 16.573ZM6.00001 18C6.26522 18 6.51958 17.8947 6.70711 17.7071C6.89465 17.5196 7.00001 17.2653 7.00001 17V14.935C6.364 14.6191 5.6926 14.379 5.00001 14.222V17C5.00001 17.2653 5.10536 17.5196 5.2929 17.7071C5.48044 17.8947 5.73479 18 6.00001 18Z" fill="#D5A230"/>
                    </svg>
                    <span class="card-label">Garage Name</span>
                </div>
                <div class="card-text">
                <span class="card-value">{{ garageName }}</span>
                </div>
            </div>

            <div class="wc-card-unique">
                <div class="card-icon-and-class-name">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6 2C5.73478 2 5.48043 2.10536 5.29289 2.29289C5.10536 2.48043 5 2.73478 5 3V4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V16C2 16.5304 2.21071 17.0391 2.58579 17.4142C2.96086 17.7893 3.46957 18 4 18H16C16.5304 18 17.0391 17.7893 17.4142 17.4142C17.7893 17.0391 18 16.5304 18 16V6C18 5.46957 17.7893 4.96086 17.4142 4.58579C17.0391 4.21071 16.5304 4 16 4H15V3C15 2.73478 14.8946 2.48043 14.7071 2.29289C14.5196 2.10536 14.2652 2 14 2C13.7348 2 13.4804 2.10536 13.2929 2.29289C13.1054 2.48043 13 2.73478 13 3V4H7V3C7 2.73478 6.89464 2.48043 6.70711 2.29289C6.51957 2.10536 6.26522 2 6 2ZM6 7C5.73478 7 5.48043 7.10536 5.29289 7.29289C5.10536 7.48043 5 7.73478 5 8C5 8.26522 5.10536 8.51957 5.29289 8.70711C5.48043 8.89464 5.73478 9 6 9H14C14.2652 9 14.5196 8.89464 14.7071 8.70711C14.8946 8.51957 15 8.26522 15 8C15 7.73478 14.8946 7.48043 14.7071 7.29289C14.5196 7.10536 14.2652 7 14 7H6Z" fill="#D5A230"/>
                    </svg>
                    <span class="card-label">Date of Purchase</span>
                </div>
                <div class="card-text">
                <span class="card-value">{{ purchaseDate | date:'dd MMM yyyy' | uppercase }}</span>
                </div>
            </div>

            <div class="wc-card-unique">
                <div class="card-icon-and-class-name">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18ZM11 6C11 5.73478 10.8946 5.48043 10.7071 5.29289C10.5196 5.10536 10.2652 5 10 5C9.73478 5 9.48043 5.10536 9.29289 5.29289C9.10536 5.48043 9 5.73478 9 6V10C9.00006 10.2652 9.10545 10.5195 9.293 10.707L12.121 13.536C12.2139 13.6289 12.3242 13.7026 12.4456 13.7529C12.567 13.8032 12.6971 13.8291 12.8285 13.8291C12.9599 13.8291 13.09 13.8032 13.2114 13.7529C13.3328 13.7026 13.4431 13.6289 13.536 13.536C13.6289 13.4431 13.7026 13.3328 13.7529 13.2114C13.8032 13.09 13.8291 12.9599 13.8291 12.8285C13.8291 12.6971 13.8032 12.567 13.7529 12.4456C13.7026 12.3242 13.6289 12.2139 13.536 12.121L11 9.586V6Z" fill="#D5A230"/>
                    </svg>
                    <span class="card-label">Warranty Period</span>
                </div>
                <div class="card-text">
                <span class="card-value">As per manufacturer’s policy</span>
                </div>
            </div>
        </div>

        <div class="vehicle-details-container">
            <div class="vehicle-details-container-left-divs" >
                <div class="vd-header">
                     <div class="vehicle-details-svg-bg">
                        <img src="../../../../assets/images/car-images/gold-car.png">
                    </div>

                    <span>Vehicle Details</span>
                </div>

                <div class="vd-row">
                    <div class="vd-label">Make & Model</div>
                    <div class="vd-value">{{ make }} {{ model }}</div>
                </div>

                <div class="vd-row">
                    <div class="vd-label">Year & Variant</div>
                    <div class="vd-value">{{ mfgYear }} {{ variant }}</div>
                </div>

                <div class="vd-row">
                    <div class="vd-label">Fuel Type</div>
                    <div class="vd-value">{{ fuelType }}</div>
                </div>
            </div>
            <!-- Registration Box (already done earlier) -->
            <div class="vehicle-reg">
                <div class="vehicle-reg-num">Registration Number</div>
                <div class="reg-number">{{ getFormattedRegNo(registrationNumber) }}</div>
            </div>

        </div>



        <h2 class="wc-covered-title-unique">Covered Parts</h2>

        <table class="wc-table-unique" *ngIf="warrantyDetails?.orderItems?.length">
        <thead>
            <tr>
            <th>Part Name</th>
            <th>Part Number</th>
            <th>Brand</th>
            <th>Quantity</th>
            </tr>
        </thead>
        <tbody *ngIf="brandedWarrantyItems.length">
                <tr *ngFor="let item of brandedWarrantyItems">
                <td>{{ item.name || 'N/A' }}</td>
                <td class="part-number-cell">{{ item.partNumber || 'N/A' }}</td>
                <td>{{ item.brandName || 'N/A' }}</td>
                <td>{{ item.quantity || 0 }}</td>
                </tr>
        </tbody>
        </table>

        <p *ngIf="!warrantyDetails?.orderItems?.length">No items found for this order.</p>
    </div>

    </div>
    <div class="wc-buttons-unique">
        <button class="wc-btn-terms-unique" (click)="toggleWarrantyUI()">View Terms & Conditions</button>
        <button class="wc-btn-download-unique" (click)="downloadSinglePDFWithTwoDivs()">Download PDF</button>
        <button class="wc-btn-whatsapp-unique" (click)="shareOnWhatsApp()">Share on WhatsApp</button>
    </div>
</div>

<!-- TERMS & CONDITIONS MODAL -->
<div class="tcu-modal-unique"  *ngIf="showWarrantyUI"> 
    <div class="tcu-content-unique" id="termsDiv">
    <div class="tcu-box-unique">
      <!-- Header -->
      <div class="tcu-logo-box-unique">
        <img src="../../../../assets/icons/autoverse-logo.jfif">
      </div>

      <h2 class="tcu-title-unique">Terms & Conditions</h2>

       <ol class="tcu-list-unique">
        <li *ngFor="let term of termsAndConditionList">
          {{ term }}
        </li>
      </ol>

      <p class="tcu-footer-text-unique">
        Autoverse – India’s Trusted Genuine Automotive Parts Platform
      </p>
    </div>
  </div>
     <div class="wc-buttons-unique">
        <button class="wc-btn-terms-unique" (click)="toggleCertificateUI()">View Certificate</button>
        <button class="wc-btn-download-unique" (click)="downloadSinglePDFWithTwoDivs()">Download PDF</button>
        <button class="wc-btn-whatsapp-unique" (click)="shareOnWhatsApp()">Share on WhatsApp</button>
    </div>
</div>

